import { State } from './definition.state';
import { providerProduct, Product } from '../providers/provider.product';
import { stored_init_options } from '../module';
declare type InputParameterTypeLocal = { area: number, coordinates: number[][] };
declare type PassOverParameterTypeLocal = { area: number, coordinates: number[][], products: string[], name: string };

export class StateSelectProduct extends State<InputParameterTypeLocal, PassOverParameterTypeLocal> {

    private _products: Product[] = [];
    private _friendlyNameDiv?: HTMLDivElement;
    private _friendlyNameInput?: HTMLInputElement;
    private _areaDiv?: HTMLDivElement;
    private _priceDiv?: HTMLDivElement;

    // override
    constructor(parent_container: HTMLDivElement) {
        super(parent_container);
        this.id = 'select-product';
        this.buildDom(parent_container);
    }

    // override
    public activateAndInit(inputPrameters: InputParameterTypeLocal) {
        super.activateAndInit(inputPrameters);
        if (this._areaDiv) {
            this._areaDiv.getElementsByTagName("span")[0].innerHTML = (Math.round(inputPrameters.area / 1000) * 1000 / 10000).toFixed(0) + " ha";
        }
        this.updatePrice();
    }


    // override
    get passOverPrameters() {
        if (this._inputPrameters !== undefined) {
            console.log(this._products);
            this._passOverPrameters = { name: (this._friendlyNameInput) ? this._friendlyNameInput.value : "", area: this._inputPrameters.area, coordinates: this._inputPrameters.coordinates, products: this._products.filter(p => p.fixed === true || p.selected === true).map(p => p.id) };
            console.log(this._passOverPrameters);
        }
        return super.passOverPrameters;
    }


    private async buildDom(parent_container: HTMLDivElement) {
        let stateItem = this.createDomItem(parent_container, 'product-selector-container', { modeDomLink: ['default'], stateItem: true });

        this._products = await providerProduct.get();



        // Table header
        let o = this.createDomItem(stateItem, '', { className: 'product-selector-item' }); o.style.margin = '0px'; o.style.fontWeight = "bold";
        let table = document.createElement("table");
        table.style.borderCollapse = "collapse";
        table.id = "product-table";
        table.innerHTML = `<tr>
            <th style="width:50px;">Prod.</th>
            <th style="width:142px;">Product name</th>
            <th style="overflow:hidden;">Report content</th>
            <th style="width:70px;">Example reports</th>
            <th style="width:70px;">Price (ex VAT)</th>
            <th style="width:70px;">Purchase</th>
            </tr>`;
        o.appendChild(table);



        // let n = this.createDomItem(o, '', { className: 'product-select-line' });
        //     table.innerHTML = `<div style="width:50px;">Prod.</div>
        // <div style="width:142px;display: table-cell;">Product name</div>
        // <div style="width:100%;overflow:hidden;display: table-cell;">Report content</div>
        // <div style="width:70px;line-height:18px;display: table-cell;">Example reports</div>
        // <div style="width:70px;line-height:18px;display: table-cell;">Price (ex VAT)</div>
        // <div style="width:70px;display: table-cell;">Purchase</div>`;
        // }

        this._products.forEach((p, i) => {
            p.selected = false;
            p._price_div = this.createProductSelectItem(table.tBodies[0], p, i);
        });




        // this._friendlyNameDiv = this.createDomItem(stateItem, 'product-selector-friendly-name', {});
        // this._friendlyNameDiv.innerHTML = '<div id="product-selector-friendly-name-div">Friendly Name</div>' + "<input placeholder='E.g Home Farm'/>";
        // this._friendlyNameInput = this._friendlyNameDiv.getElementsByTagName("input")[0];
        // let _label_price_div = this.createDomItem(this._friendlyNameDiv, 'product-selector-label-price', {}).innerHTML = providerProduct.label_price;




        this._friendlyNameDiv = this.createDomItem(stateItem, 'product-selector-friendly-name-2', {});
        this._friendlyNameDiv.innerHTML = '<div>Project name</div>' + "<input placeholder='E.g Home Farm'/>";
        this._friendlyNameInput = this._friendlyNameDiv.getElementsByTagName("input")[0];
        // this._friendlyNameDiv.style.display = 'none';
        // let _label_price_div = this.createDomItem(stateItem, 'product-selector-label-price-2', {}).innerHTML = providerProduct.label_price;

        this._areaDiv = this.createDomItem(stateItem, 'product-selector-area', {});
        this._areaDiv.innerHTML = "<div>Area</div>" + "<span></span>";

        this._priceDiv = this.createDomItem(stateItem, 'product-selector-price', {});
        this._priceDiv.innerHTML = "<div>Price</div>" + "<span></span>";

        {
            let stateItem_ = this.createDomItem(parent_container, 'product-navigate', { className: 'global-selector-navigate-container', modeDomLink: ['default'], stateItem: true });
            let p_ = this.createDomItem(stateItem_, 'product-previous', { className: 'global-selector-navigate', stateChange: { sourceStateId: this.id, targetStateId: 'select-area' } }); p_.innerHTML = ' < back';
            let n_ = this.createDomItem(stateItem_, 'product-next', { className: 'global-selector-navigate', customToggleDomItem: { initialStatus: false }, stateChange: { sourceStateId: this.id, targetStateId: 'select-dataset' } }); n_.innerHTML = 'next > ';
            let n_dummy = this.createDomItem(stateItem_, 'product-selector-next-disabled', { className: 'global-selector-navigate', customToggleDomItem: { initialStatus: true } }); n_dummy.innerHTML = 'next > ';

            // n_.addEventListener('click', () => {
            //     let geom = (this._inputPrameters !== undefined) ? this._inputPrameters.coordinates : [];
            // });
        }
        this.setMode('default');
    }


    private createProductSelectItem(parent_container: HTMLDivElement, product: Product, index: number) {

        let tr = document.createElement("tr");
        parent_container.appendChild(tr);
        let link = "-";
        if (stored_init_options.product_sample_link && stored_init_options.product_sample_link[index]) {
            link = `<a href="${stored_init_options.product_sample_link[index]}" target="_blank">here</a>`;
        }
        tr.innerHTML = `<td style="width:64px;">${index + 1}</td>
        <td style="width:133px;">${product.name}</td>
        <td style="width:100%;"><div style="overflow:hidden;">${product.short_label}</div></td>
        <td style="width:70px;text-align:center;">${link}</td>
        `;

        // let o = this.createDomItem(parent_container, '', { className: 'product-selector-item' });
        // o.style.margin = '0px';

        let s: HTMLInputElement = document.createElement("input");
        s.type = "checkbox";
        s.disabled = product.fixed || false;
        s.checked = product.fixed || false;
        s.addEventListener('change', this.onProductToggle.bind(this, product))
        product._checkbox_input = s;


        // let n = this.createDomItem(o, '', { className: 'product-select-line' });
        // n.innerHTML = `<div style="width:64px;display: table-cell;">${index + 1}</div><div style="width:133px;display: table-cell;">${product.name}</div><div style="display: table-cell;overflow:hidden;width:100%;">${product.short_label}</div><div style="width:70px;">here</div>`;


        // let n1 = this.createDomItem(o, '', {});
        // n1.innerHTML = 'price'
        // n1.style.width = '70px';
        // n.appendChild(n1);

        // let n2 = this.createDomItem(o, '', {});
        // n2.style.width = '70px';
        // n.appendChild(n2);
        // n2.appendChild(s);

        // return n1;

        let n1 = document.createElement("td");
        tr.appendChild(n1);

        let n2 = document.createElement("td");
        tr.appendChild(n2);
        n2.appendChild(s);

        return n1;
    }


    private updateGroupModuleUI() {
        this._products.forEach(p => {
            if (p._checkbox_input !== undefined) {
                p._checkbox_input.disabled = false;
            }
        });

        this._products.forEach(p => {
            // console.log(p);
            if (p.selected === true && p.modules !== undefined) {
                this._products.forEach(pp => {
                    if (p.modules !== undefined && p.modules.indexOf(pp.id) !== -1 && pp._checkbox_input !== undefined) {
                        pp.selected = false;
                        pp._checkbox_input.checked = false;
                        pp._checkbox_input.disabled = true;
                    }
                });
            }
        });

    }


    private updatePrice() {
        this.customToggleDomItem('product-next', this._products.some(p => p.selected === true || p.fixed === true));
        this.customToggleDomItem('product-selector-next-disabled', !this._products.some(p => p.selected === true || p.fixed === true));

        let product_set = providerProduct.procuct_set(this._products.filter(p => p.selected === true || p.fixed === true).map(p => p.id));
        let postComputePrice: (price: number) => number = (price: number) => { return price; }
        if (product_set !== undefined) {
            postComputePrice = product_set.price;
        }


        this._products.forEach(p => {
            // console.log(p);
            if (p._price_div !== undefined && this._inputPrameters !== undefined) {
                let ar = Math.round(this._inputPrameters.area / 1000) * 1000;
                let price = postComputePrice(p.price(ar / 10000)).toFixed(0);
                // console.log(price);
                p._price_div.innerHTML = '£ ' + price;
            }
        });
        let area_ha = (this._inputPrameters) ? Math.round(this._inputPrameters.area / 1000) * 1000 / 10000 : 4;
        let price: number = this._products.filter(p => p.fixed || p.selected).map(p => postComputePrice(p.price(area_ha))).reduce((p, n) => p + n, 0);
        if (this._priceDiv) {
            this._priceDiv.getElementsByTagName("span")[0].innerHTML = price.toFixed(2) + " &#163;";
        }
    }
    private onProductToggle(product: Product, ev: { target: { checked: boolean } }) {
        product.selected = ev.target.checked;
        this.updateGroupModuleUI();
        this.updatePrice();
    }



}
